import { getAuthToken } from '../firebase/firebase';
const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Create a payment intent for token purchase
 * @param {Object} packageDetails - Package details object with tokens and price
 * @returns {Promise<Object>} - Payment intent client secret
 */
export const createPaymentIntent = async (packageDetails) => {
  try {
    const token = getAuthToken();
    if (!token) {
      throw new Error('User not authenticated');
    }
    
    const response = await fetch(`${API_BASE_URL}/payments/create-payment-intent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        tokens: packageDetails.tokens,
        price: packageDetails.price
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create payment intent');
    }
    
    const data = await response.json();
    return data.clientSecret;
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};

/**
 * Process a successful payment and add tokens to the user's account
 * @param {Object} purchaseDetails - Object containing purchase details
 * @returns {Promise<Object>} Updated token balance and transaction details
 */
export const processTokenPurchase = async (purchaseDetails) => {
  try {
    const { paymentIntentId, packageDetails } = purchaseDetails;
    const token = getAuthToken();
    if (!token) {
      throw new Error('User not authenticated');
    }
    
    const response = await fetch(`${API_BASE_URL}/payments/process-purchase`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        paymentIntentId,
        tokens: packageDetails.tokens,
        price: packageDetails.price
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to process token purchase');
    }
    
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error processing token purchase:', error);
    throw error;
  }
}; 